
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Used to direct users to a different page or to provide access to further information.`}</p>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`to lead a user to another page.`}</li>
      <li parentName="ul">{`to signal email functionality by styling the address.`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`to submit or confirm an action. Use a button instead.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;